import {
  Button,
  Form,
} from '@skyline-platform/alchemy';
import LinearProgress from '@mui/material/LinearProgress';

export const ImportProgressForm = (properties) => {
  const {
    filename,
    rowsProcessed,
    totalRowCount,
    handleCancelProcess,
    notification,
    totalErrorCount,
    totalSuccessCount,
  } = properties ?? {};
  return (
    <Form
      formTitle={`processing-upload-file`}
      footer={[
        <div key='notification' className='notification'>
          <span className='importing'>{notification?.message}</span>
          <span className='failures'>{totalErrorCount} imports failed.</span>
        </div>,
      ]}
    >
      <div className='filename-and-count'>
        <span className='filename'>{filename}</span>
        <span className='current-count'>{totalSuccessCount}/{totalRowCount}</span>
      </div>
      <div className='progress-bar'>
        <LinearProgress variant='determinate' value={Math.round(rowsProcessed / totalRowCount * 100)} />
        <Button
          state='default'
          type='text'
          iconLeft='fa-sharp-duotone fa-solid fa-circle-xmark'
          className='cancel-process'
          handleClick={handleCancelProcess}
        />
      </div>
    </Form>
  );
};